import React, { useEffect, useState, useMemo } from "react";
import Quick_links from "../utility/Quick_links";
import makeAnimated from "react-select/animated"; // Keep for other parts if needed
import services from "../services/services";
import { useForm } from "react-hook-form";
import $ from 'jquery';
import { useNavigate } from "react-router-dom";

const WageData = () => {
    const navigate = useNavigate();
    
    // --- State Management ---
    const [stateList, setStateList] = useState([]);
    const [countyList, setCountyList] = useState([]);
    const [jobSuggestions, setJobSuggestions] = useState([]); // For the custom dropdown
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [inputValue, setInputValue] = useState("");
    
    const [socCode, setSocCode] = useState('');
    const [jobCodeTitle, setJobCode] = useState('');
    
    // Wage Data States
    const [wageData, setWageData] = useState({
        dolYearly: {},
        dolHourly: {},
        surveyYearly: {},
        surveyHourly: {}
    });

    const companyIdChkLogin = sessionStorage.getItem("logCompanyId") || localStorage.getItem("logCompanyId");

    const { handleSubmit } = useForm({ criteriaMode: "all", mode: "onBlur" });

    // --- Effects ---
    useEffect(() => {
        if (!companyIdChkLogin || companyIdChkLogin === "null") {
            navigate('/Home');
            return;
        }

        getStatesWage();
        
        // Initial state load
        setTimeout(() => {
            $("#stateId").val('OH');
            getCountyByState('OH');
        }, 500);

        // Close suggestions when clicking outside
        const handleClickOutside = () => setShowSuggestions(false);
        window.addEventListener("click", handleClickOutside);
        return () => window.removeEventListener("click", handleClickOutside);
    }, []);

    // --- API Calls ---
    const getStatesWage = () => {
        services.getStatesFromWage().then((res) => setStateList(res.data || []));
    };

    const getCountyByState = (stateId) => {
        services.getCountyByStateFromWage({ 
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ "stateCode": stateId }) 
        }).then((res) => setCountyList(res || []));
    };

    // --- Custom Autocomplete Logic ---
    const handleJobSearch = (e) => {
        const value = e.target.value;
        setInputValue(value);

        if (value.length > 1) {
            fetch('https://wagesurvey.hometownopportunity.com/api/jobSugList', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ title: value }),
            })
            .then(res => res.json())
            .then(data => {
                setJobSuggestions(data || []);
                setShowSuggestions(true);
            });
        } else {
            setJobSuggestions([]);
        }
    };

    const selectJob = (item) => {
        setJobCode(item.title);
        setSocCode(item.socCode);
        setInputValue(item.title);
        setShowSuggestions(false);
    };

    const getWageInfoCall = () => {
        const requestObject = {
            "stateCode": $("#stateId").val(),
            "county": $("#countyId").val(),
            "job_code": jobCodeTitle,
            "soccode": socCode,
        };

        services.getSurveyWageList({
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestObject)
        }).then((res) => {
            if (res) {
                setWageData({
                    dolYearly: res.dolWage?.[0] || {},
                    dolHourly: res.dolWageHourly?.[0] || {},
                    surveyYearly: res.surveyWage?.[0] || {},
                    surveyHourly: res.surveyWageHourly?.[0] || {}
                });
            }
        });
    };

    return (
        <main className="empr-directory-main">
            <div className="main-bgpatten"></div>
            <section className="headtitle-wrap">
                <div className="container">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item headtitle "><a href="/companyJobs">Company Dashboard</a></li>
                            <li className="breadcrumb-item headtitle  active">Wage Data</li>
                        </ol>
                    </nav>
                </div>
            </section>

            <section className="py-5">
                <div className="container">
                    <div className="white-bg p-5">
                        <div className="row">
                            <Quick_links />
                            
                            <div className="col-lg-8 mb-4">
                                <div className="row resume-wrap">
                                    {/* State Dropdown */}
                                    <div className="col-lg-12 mb-4">
                                        <label className="form-label">State<span className="red-text">*</span></label>
                                        <select className="form-select" id="stateId" onChange={(e) => getCountyByState(e.target.value)}>
                                            <option value="">Select State</option>
                                            {stateList.map((data) => (
                                                <option key={data.stateCode} value={data.stateCode}>{data.stateName}</option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* County Dropdown */}
                                    <div className="col-lg-12 mb-4">
                                        <label className="form-label">County<span className="red-text">*</span></label>
                                        <select className="form-select" id="countyId">
                                            <option value="">Select County</option>
                                            {countyList.map((data, index) => (
                                                <option key={index} value={data.countyName}>{data.countyName}</option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* CUSTOM AUTOCOMPLETE INPUT */}
                                    <div className="col-lg-12 mb-4 position-relative">
                                        <label className="form-label">Standardized Job Title<span className="red-text">*</span></label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            value={inputValue} 
                                            onChange={handleJobSearch}
                                            placeholder="Type to search jobs..."
                                            autoComplete="off"
                                        />
                                        {showSuggestions && jobSuggestions.length > 0 && (
                                            <ul className="list-group position-absolute w-100 z-index-100" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                                                {jobSuggestions.map((item, idx) => (
                                                    <li 
                                                        key={idx} 
                                                        className="list-group-item list-group-item-action" 
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => selectJob(item)}
                                                    >
                                                        {item.title} <small className="text-muted">({item.socCode})</small>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>

                                    <div className="col-lg-12 mb-4">
                                        <p><strong>Selected SOC Code:</strong> {socCode}</p>
                                        <button type="button" onClick={getWageInfoCall} className="reg-button">Search Wage Data</button>
                                    </div>

                                    {/* RESULTS TABLE */}
                                    <div className="col-lg-12 mb-4">
                                        <table className="table wage-data-tb table-bordered">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th>SOURCE</th>
                                                    <th>Type</th>
                                                    <th>LEVEL-1</th>
                                                    <th>LEVEL-2</th>
                                                    <th>LEVEL-3</th>
                                                    <th>LEVEL-4</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* DOL Data Rows */}
                                                <tr>
                                                    <th rowSpan="2">DOL Wage Data</th>
                                                    <td>Yearly</td>
                                                    <td>{wageData.dolYearly.level1}</td>
                                                    <td>{wageData.dolYearly.level2}</td>
                                                    <td>{wageData.dolYearly.level3}</td>
                                                    <td>{wageData.dolYearly.level4}</td>
                                                </tr>
                                                <tr>
                                                    <td>Hourly</td>
                                                    <td>{wageData.dolHourly.level1}</td>
                                                    <td>{wageData.dolHourly.level2}</td>
                                                    <td>{wageData.dolHourly.level3}</td>
                                                    <td>{wageData.dolHourly.level4}</td>
                                                </tr>
                                                {/* Survey Data Rows */}
                                                <tr>
                                                    <th rowSpan="2">Local Survey</th>
                                                    <td>Yearly</td>
                                                    <td>{wageData.surveyYearly.level1}</td>
                                                    <td>{wageData.surveyYearly.level2}</td>
                                                    <td>{wageData.surveyYearly.level3}</td>
                                                    <td>{wageData.surveyYearly.level4}</td>
                                                </tr>
                                                <tr>
                                                    <td>Hourly</td>
                                                    <td>{wageData.surveyHourly.level1}</td>
                                                    <td>{wageData.surveyHourly.level2}</td>
                                                    <td>{wageData.surveyHourly.level3}</td>
                                                    <td>{wageData.surveyHourly.level4}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default WageData;